/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicSignUpRouteImport } from './routes/_public/sign-up'
import { Route as PublicSignInRouteImport } from './routes/_public/sign-in'
import { Route as AuthAppSelectOrganizationRouteImport } from './routes/_auth/app/select-organization'
import { Route as AuthAppAppRouteImport } from './routes/_auth/app/_app'
import { Route as AuthAppAppIndexRouteImport } from './routes/_auth/app/_app/index'
import { Route as AuthAppBillingReturnRouteImport } from './routes/_auth/app/billing/return'
import { Route as AuthAppAppOrgOrgIdRouteImport } from './routes/_auth/app/_app/org/$orgId'
import { Route as AuthAppAppOrgOrgIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/index'
import { Route as AuthAppAppOrgOrgIdSettingsIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/settings/index'
import { Route as AuthAppAppOrgOrgIdBillingIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/billing/index'
import { Route as AuthAppAppOrgOrgIdAppAppIdRouteImport } from './routes/_auth/app/_app/org/$orgId/app/$appId'
import { Route as AuthAppAppOrgOrgIdAppAppIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/app/$appId/index'
import { Route as AuthAppAppOrgOrgIdAppAppIdSenderIdentitiesIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/app/$appId/sender-identities/index'
import { Route as AuthAppAppOrgOrgIdAppAppIdMessagesIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/app/$appId/messages/index'
import { Route as AuthAppAppOrgOrgIdAppAppIdApiKeysIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/app/$appId/api-keys/index'
import { Route as AuthAppAppOrgOrgIdAppAppIdMessagesMessageIdRouteImport } from './routes/_auth/app/_app/org/$orgId/app/$appId/messages/$messageId'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicSignUpRoute = PublicSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignInRoute = PublicSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => PublicRoute,
} as any)
const AuthAppSelectOrganizationRoute =
  AuthAppSelectOrganizationRouteImport.update({
    id: '/app/select-organization',
    path: '/app/select-organization',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAppAppRoute = AuthAppAppRouteImport.update({
  id: '/app/_app',
  path: '/app',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAppAppIndexRoute = AuthAppAppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAppAppRoute,
} as any)
const AuthAppBillingReturnRoute = AuthAppBillingReturnRouteImport.update({
  id: '/app/billing/return',
  path: '/app/billing/return',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAppAppOrgOrgIdRoute = AuthAppAppOrgOrgIdRouteImport.update({
  id: '/org/$orgId',
  path: '/org/$orgId',
  getParentRoute: () => AuthAppAppRoute,
} as any)
const AuthAppAppOrgOrgIdIndexRoute = AuthAppAppOrgOrgIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAppAppOrgOrgIdRoute,
} as any)
const AuthAppAppOrgOrgIdSettingsIndexRoute =
  AuthAppAppOrgOrgIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdBillingIndexRoute =
  AuthAppAppOrgOrgIdBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdAppAppIdRoute =
  AuthAppAppOrgOrgIdAppAppIdRouteImport.update({
    id: '/app/$appId',
    path: '/app/$appId',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdAppAppIdIndexRoute =
  AuthAppAppOrgOrgIdAppAppIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAppOrgOrgIdAppAppIdRoute,
  } as any)
const AuthAppAppOrgOrgIdAppAppIdSenderIdentitiesIndexRoute =
  AuthAppAppOrgOrgIdAppAppIdSenderIdentitiesIndexRouteImport.update({
    id: '/sender-identities/',
    path: '/sender-identities/',
    getParentRoute: () => AuthAppAppOrgOrgIdAppAppIdRoute,
  } as any)
const AuthAppAppOrgOrgIdAppAppIdMessagesIndexRoute =
  AuthAppAppOrgOrgIdAppAppIdMessagesIndexRouteImport.update({
    id: '/messages/',
    path: '/messages/',
    getParentRoute: () => AuthAppAppOrgOrgIdAppAppIdRoute,
  } as any)
const AuthAppAppOrgOrgIdAppAppIdApiKeysIndexRoute =
  AuthAppAppOrgOrgIdAppAppIdApiKeysIndexRouteImport.update({
    id: '/api-keys/',
    path: '/api-keys/',
    getParentRoute: () => AuthAppAppOrgOrgIdAppAppIdRoute,
  } as any)
const AuthAppAppOrgOrgIdAppAppIdMessagesMessageIdRoute =
  AuthAppAppOrgOrgIdAppAppIdMessagesMessageIdRouteImport.update({
    id: '/messages/$messageId',
    path: '/messages/$messageId',
    getParentRoute: () => AuthAppAppOrgOrgIdAppAppIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/sign-in': typeof PublicSignInRoute
  '/sign-up': typeof PublicSignUpRoute
  '/app': typeof AuthAppAppRouteWithChildren
  '/app/select-organization': typeof AuthAppSelectOrganizationRoute
  '/app/billing/return': typeof AuthAppBillingReturnRoute
  '/app/': typeof AuthAppAppIndexRoute
  '/app/org/$orgId': typeof AuthAppAppOrgOrgIdRouteWithChildren
  '/app/org/$orgId/': typeof AuthAppAppOrgOrgIdIndexRoute
  '/app/org/$orgId/app/$appId': typeof AuthAppAppOrgOrgIdAppAppIdRouteWithChildren
  '/app/org/$orgId/billing/': typeof AuthAppAppOrgOrgIdBillingIndexRoute
  '/app/org/$orgId/settings/': typeof AuthAppAppOrgOrgIdSettingsIndexRoute
  '/app/org/$orgId/app/$appId/': typeof AuthAppAppOrgOrgIdAppAppIdIndexRoute
  '/app/org/$orgId/app/$appId/messages/$messageId': typeof AuthAppAppOrgOrgIdAppAppIdMessagesMessageIdRoute
  '/app/org/$orgId/app/$appId/api-keys/': typeof AuthAppAppOrgOrgIdAppAppIdApiKeysIndexRoute
  '/app/org/$orgId/app/$appId/messages/': typeof AuthAppAppOrgOrgIdAppAppIdMessagesIndexRoute
  '/app/org/$orgId/app/$appId/sender-identities/': typeof AuthAppAppOrgOrgIdAppAppIdSenderIdentitiesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/sign-in': typeof PublicSignInRoute
  '/sign-up': typeof PublicSignUpRoute
  '/app/select-organization': typeof AuthAppSelectOrganizationRoute
  '/app/billing/return': typeof AuthAppBillingReturnRoute
  '/app': typeof AuthAppAppIndexRoute
  '/app/org/$orgId': typeof AuthAppAppOrgOrgIdIndexRoute
  '/app/org/$orgId/billing': typeof AuthAppAppOrgOrgIdBillingIndexRoute
  '/app/org/$orgId/settings': typeof AuthAppAppOrgOrgIdSettingsIndexRoute
  '/app/org/$orgId/app/$appId': typeof AuthAppAppOrgOrgIdAppAppIdIndexRoute
  '/app/org/$orgId/app/$appId/messages/$messageId': typeof AuthAppAppOrgOrgIdAppAppIdMessagesMessageIdRoute
  '/app/org/$orgId/app/$appId/api-keys': typeof AuthAppAppOrgOrgIdAppAppIdApiKeysIndexRoute
  '/app/org/$orgId/app/$appId/messages': typeof AuthAppAppOrgOrgIdAppAppIdMessagesIndexRoute
  '/app/org/$orgId/app/$appId/sender-identities': typeof AuthAppAppOrgOrgIdAppAppIdSenderIdentitiesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_public/sign-in': typeof PublicSignInRoute
  '/_public/sign-up': typeof PublicSignUpRoute
  '/_auth/app/_app': typeof AuthAppAppRouteWithChildren
  '/_auth/app/select-organization': typeof AuthAppSelectOrganizationRoute
  '/_auth/app/billing/return': typeof AuthAppBillingReturnRoute
  '/_auth/app/_app/': typeof AuthAppAppIndexRoute
  '/_auth/app/_app/org/$orgId': typeof AuthAppAppOrgOrgIdRouteWithChildren
  '/_auth/app/_app/org/$orgId/': typeof AuthAppAppOrgOrgIdIndexRoute
  '/_auth/app/_app/org/$orgId/app/$appId': typeof AuthAppAppOrgOrgIdAppAppIdRouteWithChildren
  '/_auth/app/_app/org/$orgId/billing/': typeof AuthAppAppOrgOrgIdBillingIndexRoute
  '/_auth/app/_app/org/$orgId/settings/': typeof AuthAppAppOrgOrgIdSettingsIndexRoute
  '/_auth/app/_app/org/$orgId/app/$appId/': typeof AuthAppAppOrgOrgIdAppAppIdIndexRoute
  '/_auth/app/_app/org/$orgId/app/$appId/messages/$messageId': typeof AuthAppAppOrgOrgIdAppAppIdMessagesMessageIdRoute
  '/_auth/app/_app/org/$orgId/app/$appId/api-keys/': typeof AuthAppAppOrgOrgIdAppAppIdApiKeysIndexRoute
  '/_auth/app/_app/org/$orgId/app/$appId/messages/': typeof AuthAppAppOrgOrgIdAppAppIdMessagesIndexRoute
  '/_auth/app/_app/org/$orgId/app/$appId/sender-identities/': typeof AuthAppAppOrgOrgIdAppAppIdSenderIdentitiesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/sign-up'
    | '/app'
    | '/app/select-organization'
    | '/app/billing/return'
    | '/app/'
    | '/app/org/$orgId'
    | '/app/org/$orgId/'
    | '/app/org/$orgId/app/$appId'
    | '/app/org/$orgId/billing/'
    | '/app/org/$orgId/settings/'
    | '/app/org/$orgId/app/$appId/'
    | '/app/org/$orgId/app/$appId/messages/$messageId'
    | '/app/org/$orgId/app/$appId/api-keys/'
    | '/app/org/$orgId/app/$appId/messages/'
    | '/app/org/$orgId/app/$appId/sender-identities/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sign-in'
    | '/sign-up'
    | '/app/select-organization'
    | '/app/billing/return'
    | '/app'
    | '/app/org/$orgId'
    | '/app/org/$orgId/billing'
    | '/app/org/$orgId/settings'
    | '/app/org/$orgId/app/$appId'
    | '/app/org/$orgId/app/$appId/messages/$messageId'
    | '/app/org/$orgId/app/$appId/api-keys'
    | '/app/org/$orgId/app/$appId/messages'
    | '/app/org/$orgId/app/$appId/sender-identities'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_public'
    | '/_public/sign-in'
    | '/_public/sign-up'
    | '/_auth/app/_app'
    | '/_auth/app/select-organization'
    | '/_auth/app/billing/return'
    | '/_auth/app/_app/'
    | '/_auth/app/_app/org/$orgId'
    | '/_auth/app/_app/org/$orgId/'
    | '/_auth/app/_app/org/$orgId/app/$appId'
    | '/_auth/app/_app/org/$orgId/billing/'
    | '/_auth/app/_app/org/$orgId/settings/'
    | '/_auth/app/_app/org/$orgId/app/$appId/'
    | '/_auth/app/_app/org/$orgId/app/$appId/messages/$messageId'
    | '/_auth/app/_app/org/$orgId/app/$appId/api-keys/'
    | '/_auth/app/_app/org/$orgId/app/$appId/messages/'
    | '/_auth/app/_app/org/$orgId/app/$appId/sender-identities/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/sign-up': {
      id: '/_public/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof PublicSignUpRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-in': {
      id: '/_public/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof PublicSignInRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/app/select-organization': {
      id: '/_auth/app/select-organization'
      path: '/app/select-organization'
      fullPath: '/app/select-organization'
      preLoaderRoute: typeof AuthAppSelectOrganizationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/app/_app': {
      id: '/_auth/app/_app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AuthAppAppRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/app/_app/': {
      id: '/_auth/app/_app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AuthAppAppIndexRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/billing/return': {
      id: '/_auth/app/billing/return'
      path: '/app/billing/return'
      fullPath: '/app/billing/return'
      preLoaderRoute: typeof AuthAppBillingReturnRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/app/_app/org/$orgId': {
      id: '/_auth/app/_app/org/$orgId'
      path: '/org/$orgId'
      fullPath: '/app/org/$orgId'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/_app/org/$orgId/': {
      id: '/_auth/app/_app/org/$orgId/'
      path: '/'
      fullPath: '/app/org/$orgId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/settings/': {
      id: '/_auth/app/_app/org/$orgId/settings/'
      path: '/settings'
      fullPath: '/app/org/$orgId/settings/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSettingsIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/billing/': {
      id: '/_auth/app/_app/org/$orgId/billing/'
      path: '/billing'
      fullPath: '/app/org/$orgId/billing/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdBillingIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/app/$appId': {
      id: '/_auth/app/_app/org/$orgId/app/$appId'
      path: '/app/$appId'
      fullPath: '/app/org/$orgId/app/$appId'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdAppAppIdRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/app/$appId/': {
      id: '/_auth/app/_app/org/$orgId/app/$appId/'
      path: '/'
      fullPath: '/app/org/$orgId/app/$appId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdAppAppIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdAppAppIdRoute
    }
    '/_auth/app/_app/org/$orgId/app/$appId/sender-identities/': {
      id: '/_auth/app/_app/org/$orgId/app/$appId/sender-identities/'
      path: '/sender-identities'
      fullPath: '/app/org/$orgId/app/$appId/sender-identities/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdAppAppIdSenderIdentitiesIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdAppAppIdRoute
    }
    '/_auth/app/_app/org/$orgId/app/$appId/messages/': {
      id: '/_auth/app/_app/org/$orgId/app/$appId/messages/'
      path: '/messages'
      fullPath: '/app/org/$orgId/app/$appId/messages/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdAppAppIdMessagesIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdAppAppIdRoute
    }
    '/_auth/app/_app/org/$orgId/app/$appId/api-keys/': {
      id: '/_auth/app/_app/org/$orgId/app/$appId/api-keys/'
      path: '/api-keys'
      fullPath: '/app/org/$orgId/app/$appId/api-keys/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdAppAppIdApiKeysIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdAppAppIdRoute
    }
    '/_auth/app/_app/org/$orgId/app/$appId/messages/$messageId': {
      id: '/_auth/app/_app/org/$orgId/app/$appId/messages/$messageId'
      path: '/messages/$messageId'
      fullPath: '/app/org/$orgId/app/$appId/messages/$messageId'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdAppAppIdMessagesMessageIdRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdAppAppIdRoute
    }
  }
}

interface AuthAppAppOrgOrgIdAppAppIdRouteChildren {
  AuthAppAppOrgOrgIdAppAppIdIndexRoute: typeof AuthAppAppOrgOrgIdAppAppIdIndexRoute
  AuthAppAppOrgOrgIdAppAppIdMessagesMessageIdRoute: typeof AuthAppAppOrgOrgIdAppAppIdMessagesMessageIdRoute
  AuthAppAppOrgOrgIdAppAppIdApiKeysIndexRoute: typeof AuthAppAppOrgOrgIdAppAppIdApiKeysIndexRoute
  AuthAppAppOrgOrgIdAppAppIdMessagesIndexRoute: typeof AuthAppAppOrgOrgIdAppAppIdMessagesIndexRoute
  AuthAppAppOrgOrgIdAppAppIdSenderIdentitiesIndexRoute: typeof AuthAppAppOrgOrgIdAppAppIdSenderIdentitiesIndexRoute
}

const AuthAppAppOrgOrgIdAppAppIdRouteChildren: AuthAppAppOrgOrgIdAppAppIdRouteChildren =
  {
    AuthAppAppOrgOrgIdAppAppIdIndexRoute: AuthAppAppOrgOrgIdAppAppIdIndexRoute,
    AuthAppAppOrgOrgIdAppAppIdMessagesMessageIdRoute:
      AuthAppAppOrgOrgIdAppAppIdMessagesMessageIdRoute,
    AuthAppAppOrgOrgIdAppAppIdApiKeysIndexRoute:
      AuthAppAppOrgOrgIdAppAppIdApiKeysIndexRoute,
    AuthAppAppOrgOrgIdAppAppIdMessagesIndexRoute:
      AuthAppAppOrgOrgIdAppAppIdMessagesIndexRoute,
    AuthAppAppOrgOrgIdAppAppIdSenderIdentitiesIndexRoute:
      AuthAppAppOrgOrgIdAppAppIdSenderIdentitiesIndexRoute,
  }

const AuthAppAppOrgOrgIdAppAppIdRouteWithChildren =
  AuthAppAppOrgOrgIdAppAppIdRoute._addFileChildren(
    AuthAppAppOrgOrgIdAppAppIdRouteChildren,
  )

interface AuthAppAppOrgOrgIdRouteChildren {
  AuthAppAppOrgOrgIdIndexRoute: typeof AuthAppAppOrgOrgIdIndexRoute
  AuthAppAppOrgOrgIdAppAppIdRoute: typeof AuthAppAppOrgOrgIdAppAppIdRouteWithChildren
  AuthAppAppOrgOrgIdBillingIndexRoute: typeof AuthAppAppOrgOrgIdBillingIndexRoute
  AuthAppAppOrgOrgIdSettingsIndexRoute: typeof AuthAppAppOrgOrgIdSettingsIndexRoute
}

const AuthAppAppOrgOrgIdRouteChildren: AuthAppAppOrgOrgIdRouteChildren = {
  AuthAppAppOrgOrgIdIndexRoute: AuthAppAppOrgOrgIdIndexRoute,
  AuthAppAppOrgOrgIdAppAppIdRoute: AuthAppAppOrgOrgIdAppAppIdRouteWithChildren,
  AuthAppAppOrgOrgIdBillingIndexRoute: AuthAppAppOrgOrgIdBillingIndexRoute,
  AuthAppAppOrgOrgIdSettingsIndexRoute: AuthAppAppOrgOrgIdSettingsIndexRoute,
}

const AuthAppAppOrgOrgIdRouteWithChildren =
  AuthAppAppOrgOrgIdRoute._addFileChildren(AuthAppAppOrgOrgIdRouteChildren)

interface AuthAppAppRouteChildren {
  AuthAppAppIndexRoute: typeof AuthAppAppIndexRoute
  AuthAppAppOrgOrgIdRoute: typeof AuthAppAppOrgOrgIdRouteWithChildren
}

const AuthAppAppRouteChildren: AuthAppAppRouteChildren = {
  AuthAppAppIndexRoute: AuthAppAppIndexRoute,
  AuthAppAppOrgOrgIdRoute: AuthAppAppOrgOrgIdRouteWithChildren,
}

const AuthAppAppRouteWithChildren = AuthAppAppRoute._addFileChildren(
  AuthAppAppRouteChildren,
)

interface AuthRouteChildren {
  AuthAppAppRoute: typeof AuthAppAppRouteWithChildren
  AuthAppSelectOrganizationRoute: typeof AuthAppSelectOrganizationRoute
  AuthAppBillingReturnRoute: typeof AuthAppBillingReturnRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAppAppRoute: AuthAppAppRouteWithChildren,
  AuthAppSelectOrganizationRoute: AuthAppSelectOrganizationRoute,
  AuthAppBillingReturnRoute: AuthAppBillingReturnRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PublicRouteChildren {
  PublicSignInRoute: typeof PublicSignInRoute
  PublicSignUpRoute: typeof PublicSignUpRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicSignInRoute: PublicSignInRoute,
  PublicSignUpRoute: PublicSignUpRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
